import { Component } from 'react';

import { BraxField } from '../BraxField';
import { BraxNPSValue, BraxUncontrolledNPSField, BraxUncontrolledNPSFieldProps } from 'components/BraxUncontrolledForm/BraxUncontrolledNPSField';
import { FieldProps } from 'formik';

export type BraxNPSFieldProps = BraxUncontrolledNPSFieldProps & {
    name: string,
    readOnly?: boolean
};

export class BraxNPSField extends Component<BraxNPSFieldProps> {

    static defaultProps = {
        readOnly: false
    };

    change(value: BraxNPSValue, formik: FieldProps<any, any>) {
        formik.form.setFieldValue(this.props.name, value);

        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        const { name, hint, disabled, readOnly, onChange, ...props } = this.props;

        return (
            <BraxField name={name} hint={hint} disabled={disabled} readOnly={readOnly}>
                { ({ onChange, formik, ...fieldProps }) => (
                    <BraxUncontrolledNPSField
                        onChange={(value) => this.change(value, formik)}
                        {...fieldProps}
                        {...props}
                    />
                ) }
            </BraxField>
        );
    }

}
